/* es-lint-disable no-extra-boolean-cast no-nested-ternary */

import withRouter from '../../../hoc/withRouter';
import UserFooter from '../../footer/user-footer';
import Logos from './logos';

import { footerLinksForUserLayout, footerLinksForPreloginUserLayout } from '../../../data/footerLinks';

import { check } from '../../../utils/tokenUtils';

const layoutClassname = () => {
  if (window.location.pathname.match('/team/')) {
    return 'rep-layout';
  } else if (window.location.pathname.match('/admin/')) {
    return 'admin-layout';
  }
  return 'user-frontend';
};

const EmptyLayout = ({
  component: Component, match, location, history, ...rest
}) => {
  const matchProps = { match, location, history };

  return (
    <div className={`container-fluid ${layoutClassname()}`}>
      <div className=
        {`empty-container
        ${(!window.location.pathname.match('/team/') && !window.location.pathname.match('/admin/')) ? 'frontend-container' : ''} `}
      >
        {(window.location.pathname.match('/team/') || window.location.pathname.match('/admin/')) && (
          <header>
            <Logos />
          </header>
        )}
        {(window.location.pathname.match('/team/') || window.location.pathname.match('/admin/')) ? (
          <main>
            <Component {...matchProps} area={rest.area} />
          </main>
        ) : <Component {...matchProps} area={rest.area} />}
        {!rest.hideFooter && <UserFooter links={check() ? footerLinksForUserLayout : footerLinksForPreloginUserLayout} />}
      </div>
    </div>
  );
};

export default withRouter(EmptyLayout);
